import styled from 'styled-components';
import colors from 'styles/colors';
import { SectionTitle } from 'components/FiltersModal/components';

export const Wrapper = styled.div`
  padding-bottom: 120px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${({ gap }) => gap};
  margin-bottom: 25px;
  padding-bottom: 25px;
  padding-left: 5px;
  &:not(:last-of-type) {
    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1px;
      border-radius: 5px;
      background-color: #d0d2d7;
    }
  }
`;

export const SectionHeader = styled.button`
  width: 100%;
  padding: 0px;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Title = styled(SectionTitle)`
  &.sectionHeaderTitle {
    margin: 0;
  }
`;

export const ViewAll = styled.div`
  &:hover svg path {
    stroke: ${colors.secondary.deepCove};
  }
`;
